import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

export interface IconProps {
  /**
   * Icon name
   */
  value: string;
  /**
   * Icon color
   */
  color?: string;
  /**
   * Icon size
   */
  size?: 'sm' | 'md' | 'lg';
}

interface SVGData {
  name: string;
  publicURL: string;
  svg: {
    content?: string;
  };
}

const iconSize = {
  lg: '1.5rem',
  md: '1.25rem',
  sm: '1rem',
};

export default function Icon({
  value,
  color,
  size,
  ...props
}: IconProps & Omit<Partial<React.HTMLAttributes<HTMLDivElement>>, keyof IconProps>) {
  const icons: { [name: string]: SVGData } = Object.fromEntries(
    useStaticQuery(graphql`
      query Icons {
        allFile(filter: { sourceInstanceName: { eq: "components-assets" } }) {
          nodes {
            name
            publicURL
            svg {
              content
            }
          }
        }
      }
    `).allFile.nodes.map((e: SVGData) => [e.name, e]),
  );

  if (icons[value]?.svg.content) {
    return (
      <div
        css={{ display: 'flex', svg: { height: size && iconSize[size], fill: color ?? 'currentColor' } }}
        dangerouslySetInnerHTML={{ __html: icons[value].svg.content! }}
        {...props}
      />
    );
  } else if (icons[value]?.publicURL) {
    return <img src={icons[value].publicURL} alt={value} {...props} />;
  } else {
    return <div {...props}>{value}</div>;
  }
}
